export interface Document {
  id: string;
  name: string;
  chunkingMode?: 'GENERAL' | 'AUTOMATIC' | 'CUSTOM';
  wordCount?: number;
  retrievalCount?: number;
  creationTime: string;
  status: 'Available' | 'Processing' | 'Failed' | 'Queuing';
  enabled: boolean;
}

export enum DataSourceType {
  UploadFiles = 'UploadFiles',
  WebScraping = 'WebScraping',
}

export enum Provider {
  Jina = 'jina',
  Firecrawl = 'firecrawl',
}

export interface Dataset {
  id: string;
  name: string;
  description?: string;
  documentCount: number;
  totalWords: number;
}

